webpackJsonp([73860682185932],{

/***/ 1705:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ClientCareCreditApplication","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cardholderAvailableCredit","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"status","type":{"kind":"ENUM","name":"ClientCareCreditStatus","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-client-care-credit-application-559d0ec0660cf0087c61.js